// extracted by mini-css-extract-plugin
export default {"movies-list":"MoviesList_movies-list__A8ouM","pagination":"MoviesList_pagination__PlQ3J","btn":"MoviesList_btn__JTP-d"};